import React from "react";

export const Admin: React.FC = () => {
  return <div>You are an admin.</div>;
};
